var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAssetdistribution(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19 14.552C18.4113 16.422 17.2416 18.0556 15.6608 19.2152C14.08 20.3748 12.1705 21.0001 10.21 21C7.76736 21 5.42476 20.0297 3.69755 18.3025C1.97034 16.5752 1 14.2326 1 11.79C0.99995 9.82948 1.62517 7.92005 2.78478 6.33925C3.9444 4.75845 5.57795 3.58869 7.448 3",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.913 8.947C20.3867 7.07289 19.3873 5.3656 18.0109 3.98914C16.6344 2.61268 14.9271 1.6133 13.053 1.087C11.409 0.627997 10 2.054 10 3.76V10.454C10 11.307 10.692 11.999 11.545 11.999H18.239C19.946 11.999 21.372 10.59 20.913 8.947Z",
    stroke: "white",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAssetdistribution);
export default __webpack_public_path__ + "static/media/assetdistribution.69266530b47eb809414a3be23efb857f.svg";
export { ForwardRef as ReactComponent };